var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"icon":"mdi-login","disabled":!_vm.isTenant,"label":_vm.$t('integrations.btn.login_as'),"text":""},on:{"click":_vm.loginAs}})}
var staticRenderFns = []

export { render, staticRenderFns }